export const TRACKS = [
  {
    key: 'BOARDS',
    title: 'Boards',
    subtitle: 'Class 11 & 12 · Theory + Practicals',
    color: '#0E7490',
    desc: 'NCERT-aligned Board practice with Theory MCQs, Practicals viva, and a derivations checklist.',
  },
  {
    key: 'JEE',
    title: 'JEE (Main + Adv.)',
    subtitle: 'Physics · Chemistry · Mathematics',
    color: '#1D4ED8',
    desc: 'PYQ-style + module questions, application heavy, derivations checklist for mastery.',
  },
  {
    key: 'NEET',
    title: 'NEET (UG)',
    subtitle: 'Physics · Chemistry · Biology',
    color: '#0F766E',
    desc: 'NCERT-fact-heavy MCQs, assertion-reason items, and diagram-based Biology drills.',
  },
];

export const BOARDS_MODES = [
  { key: 'BOARDS_THEORY', title: 'Theory', desc: 'NCERT theory MCQs — concepts, definitions, applications, derivations checklist.' },
  { key: 'BOARDS_PRACTICAL', title: 'Practicals', desc: 'Viva Q&A with model answers — apparatus, procedure, precautions, observations.' },
];

export const TRACK_LABELS = {
  BOARDS_THEORY: 'Boards · Theory',
  BOARDS_PRACTICAL: 'Boards · Practicals',
  JEE: 'JEE',
  NEET: 'NEET',
};

export function formatTime(totalSeconds) {
  if (totalSeconds < 0) totalSeconds = 0;
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function formatINR(n) {
  return `₹${Number(n || 0).toLocaleString('en-IN')}`;
}
